import PublicLayout from '../../../components/public/PublicLayout';
import Hero from '../../../components/public/Hero';
import Icon from '../../../components/public/Icon';
import { Panel } from '../../../components/public/Common';
import { NoRealData } from '@/components/shared';
import { occurrenceTypes } from '@/config/coletor-publico-config';

// Registro de ocorrencia ainda nao tem endpoint: sem formulario que finja enviar.
export default function OccurrencesPage(){return <PublicLayout>
 <Hero title="Ocorrências" subtitle="Sua participação faz cidades mais verdes e seguras." description="Registro de problemas relacionados às árvores urbanas de Goiânia e acompanhamento dos atendimentos." />
 <div className="page-pad">
  <div className="grid gap-3 md:grid-cols-[1fr_2fr]">
   <Panel title="Tipos de ocorrência" icon="clipboard"><div className="grid grid-cols-2 gap-2">{occurrenceTypes.map(([i,t])=><div key={t} className="flex items-center gap-2 p-2 text-xs"><Icon name={i}/><strong>{t}</strong></div>)}</div></Panel>
   <div className="space-y-3">
    <NoRealData title="Registro online de ocorrência" description="O registro de ocorrências pelo portal ainda não está disponível. Em caso de risco imediato, acione a Defesa Civil ou os canais oficiais da Prefeitura." icon="ri-alarm-warning-line"/>
    <NoRealData title="Mapa e estatísticas de ocorrências" description="Ocorrências registradas, atendimentos e tempos de resposta serão publicados quando o registro estiver em operação." icon="ri-map-pin-line"/>
   </div>
  </div>
 </div>
 </PublicLayout>}
